module.exports = __webpack_public_path__ + "cf456c9370a0c241ca21311e7494435e.jpeg";